import { memo, useMemo } from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = new RegExp(
  '^https://gist.github.com/([a-zA-Z\\d](?:[a-zA-Z\\d]|-(?=[a-zA-Z\\d])){0,38})/(.*)$',
);

export const ENABLED = [URL_REGEX];

export const Component = memo(
  ({ url, ...rest }: EmbedRendererProps<any>) => {
    const newUrl = useMemo(() => {
      const gistUrl = new URL(url);
      const id = gistUrl.pathname.split('/')[2];
      const gistLink = `https://gist.github.com/${id}.js`;
      const gistScript = `<script type="text/javascript" src="${gistLink}"></script>`;
      const styles =
        '<style>*{ font-size:12px; } .gist .blob-wrapper.data { max-height:350px; overflow:auto; }</style>';
      const iframeHtml = `<html><head><base target="_parent">${styles}</head><body>${gistScript}</body></html>`;

      return `data:text/html;base64,${btoa(iframeHtml)}`;
    }, [url]);

    return (
      <Portal
        url={newUrl}
        title="Github Gist"
        aspectRatio=""
        height="100%"
        {...rest}
      />
    );
  },
  (prevProps, nextProps) => prevProps.url === nextProps.url,
);

export default createEmbedExtension({
  regexp: [URL_REGEX],
  name: 'gist-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: false,
    defaultHeight: 500,
  }),
  addCommandOption: {
    title: 'Gist',
    description: 'Embed a Gist from GitHub.',
    searchTerms: ['embed', 'gist'],
    icon: 'tabler:code',
  },
});
